var ezdia;
(function (ezdia) {
    var NAME = 'inlineEditor';
    var TYPE = 'inlineEditor';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var pageParams = {};
    var prefix = 'ez_js_sys_inline_editor_';
    var prefixEd = 'ez_js_sys_inline_editor_ed_';
    var modulesContainerprefix = prefix + "modules_";
    var editContentContainerId = prefix + "edit_content";
    var dialogEditId = prefix + "dialog_edit";
    var dialogId = prefix + "dialog_";
    var dataEzAppend = 'data-ez-append';
    var dataEzModule = 'data-ez-module';
    var contenteditable = '[contenteditable="true"]';
    var ezContenteditable = 'data-ez-editable';
    var ezJsSysEditorInput = 'ez-js-sys-editor-input';
    var classes = {
        no_content: 'no-content',
        edit_content_layout: 'edit-content',
        edit_opt_wrap: 'ez-inline-wrapper-edit'
    };
    var inlineBaseOptions = {
        inline: true,
        paste_strip_class_attributes: 'all',
        paste_remove_spans: true,
        paste_text_sticky: true,
        forced_root_block: false,
        menubar: false,
        toolbar1: 'undo redo | bold italic underline | link unlink | table image media | spellchecker | code',
        toolbar2: 'badcontent ezdiaUpload | ice_togglechanges ice_toggleshowchanges iceacceptall icerejectall iceaccept icereject | addComment removeCommentAll removeComment | copypaste',
        plugins: ['autolink link code paste', 'ezdia'],
        gecko_spellcheck: true,
        spellchecker_language: 'en-us',
        spellchecker_languages: '+English=en-us'
    };
    var DEFAULT = {
        column: null,
        value: '',
        container: '[data-inline-editor="container"]',
        content_container: '[data-inline-editor="content container"]',
        buttons: {
            toggle: '[data-inline-editor-toggle=design], [data-inline-editor-toggle=code]',
            add: '[data-inline-editor=add]',
            edit: '[data-inline-editor="edit"]',
            edit_done: '[data-inline-editor="edit done"]'
        },
        edit_template: ezdia.templates.inlineEditor.editTemplate,
        updateRate: 1000
    };
    // =========================
    var InlineEditor = /** @class */ (function () {
        function InlineEditor(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(InlineEditor.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        InlineEditor.prototype.setValue = function (value) {
            var container = this.cache.content_container.empty();
            // eslint-disable-next-line no-param-reassign
            value = value || '';
            container.html(value);
            this.setValInTextarea(value);
            this.resetBtns();
            if (value) {
                this.renderDefaultEditors();
            }
            else {
                this.resetBtns();
            }
        };
        InlineEditor.prototype.getValue = function () {
            return this.$elem.val();
        };
        InlineEditor.prototype.setMode = function (readonly) {
            this.enableDisable(readonly);
        };
        InlineEditor.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        InlineEditor.prototype.setCache = function () {
            pageParams = $.ezdia.config.pageParams;
            var options = this.options;
            var container = $("#" + prefix + this.name);
            var obj = {};
            obj = {
                container: container,
                content_container: container.find(options.content_container),
                buttons: {
                    toggle: container.find(options.buttons.toggle),
                    add: container.find(options.buttons.add),
                    edit: container.find(options.buttons.edit),
                    edit_done: container.find(options.buttons.edit_done)
                },
                modules: {},
                modules_content: ''
            };
            return obj;
        };
        InlineEditor.prototype.init = function (options) {
            this.id = this.elem.id;
            this.name = this.elem.name;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.cache = this.setCache();
            this.count = 0;
            this.render();
        };
        InlineEditor.prototype.render = function () {
            this.setModules();
            this.setModuleContent();
            if (this.options.value) {
                this.renderDefaultEditors();
            }
            this.editorPlugin();
            this.actions();
        };
        InlineEditor.prototype.editorPlugin = function () {
            var column = this.options.column;
            var config = column.config;
            config.keywords = config.keyword || null;
            config.charcount = config.charcount || {};
            config.wordcount = config.wordcount || {};
            this.countRow = $("#ez-editor-count-" + this.name);
            var ezdiaObj = {
                readonly: !column.editable,
                inline: true,
                keywords: config.keywords,
                charcount: config.charcount,
                wordcount: config.wordcount,
                countRow: this.countRow[0],
                inlineContainer: this.cache.container,
                inlineContentContainer: this.cache.content_container
            };
            this.$elem.htmlEditor(ezdiaObj);
            if (config.config && config.config.languagetool) {
                this.$elem.htmlEditor('createLtLoading', true);
            }
            if (config.keywords) {
                this.$elem.htmlEditor('updateKeywordsCount');
            }
        };
        InlineEditor.prototype.renderDefaultEditors = function () {
            var _this = this;
            var modules = this.cache.modules || {};
            $.each(modules, function (name) {
                _this.appendSelectedModule({
                    append: false,
                    name: name
                });
            });
        };
        InlineEditor.prototype.alterModuleTemplate = function (obj, moduleName) {
            var template = $(obj.template)
                .attr(dataEzModule, moduleName)
                .prop('outerHTML');
            obj.template = template;
        };
        InlineEditor.prototype.appendSelectedModule = function (obj) {
            var _this = this;
            var cache = this.cache;
            var selectedModuleName = obj.name || cache.current_selected_module;
            var selectedModule = {};
            var selectedModuleTemplate = null;
            var selectedModuleTemplateAppend = null;
            var isAppend = obj.append;
            if (!selectedModule) {
                return;
            }
            selectedModule = cache.modules[selectedModuleName];
            selectedModuleTemplate = selectedModule.template;
            if (selectedModule.type === 'page' &&
                selectedModule.template_array.length) {
                $.each(selectedModule.template_array, function (i, name) {
                    _this.appendSelectedModule({
                        name: name,
                        append: isAppend
                    });
                });
            }
            else if (selectedModuleTemplate) {
                selectedModuleTemplateAppend = $(selectedModuleTemplate)
                    .attr(dataEzAppend, 'new')
                    .prop('outerHTML');
                if (isAppend) {
                    this.cache.content_container.append(selectedModuleTemplateAppend);
                    this.setValInTextarea(selectedModuleTemplate);
                    this.setContent();
                }
                if (selectedModuleName === 'faq') {
                    this.cache.content_container.find('.add-faq').removeAttr('disabled');
                    this.cache.content_container
                        .find('.add-faq')
                        .on('click', function (event) {
                        event.stopPropagation();
                        event.preventDefault();
                        _this.addFAQ();
                    });
                    // self.addFAQ();
                }
                this.editors({
                    name: selectedModuleName,
                    module: selectedModule,
                    append: isAppend
                });
                cache.container.removeClass(classes.no_content);
                cache.buttons.edit.show();
            }
        };
        InlineEditor.prototype.editors = function (moduleObj) {
            var _this = this;
            var self = this;
            var container = this.cache.content_container;
            var module = moduleObj.module;
            var modulePath = "[" + dataEzModule + "=\"" + moduleObj.name + "\"]";
            var suffix = ":not(" + contenteditable + ")";
            var newAppend = "[" + dataEzAppend + "=\"new\"]";
            if (moduleObj.append) {
                modulePath += newAppend;
            }
            $.each(module.path, function (i, path) {
                var pathSplit = path.split('>');
                var pathQuery = '';
                pathSplit = pathSplit.map(function (str) { return str.trim(); });
                pathSplit[0] += modulePath;
                pathQuery = pathSplit.join(suffix + " > ") + suffix;
                var elem = container.find(pathQuery);
                if (elem.length && !elem.find(contenteditable).length) {
                    _this.renderEditor({
                        config: module.config,
                        elements: elem,
                        field_name: self.name,
                        ltLocalStorageKey: self.cache.ltLocalStorageKey
                    });
                }
            });
            if (moduleObj.append) {
                container.find(newAppend).removeAttr(dataEzAppend);
            }
        };
        InlineEditor.prototype.renderEditor = function (obj) {
            var _this = this;
            var self = this;
            $.each(obj.elements, function (i, element) {
                var elem = $(element);
                var id = elem.attr('id') || prefixEd + self.count;
                var tagName = element.tagName;
                var options = _this.getEditorOptions({
                    config: obj.config,
                    tagName: tagName,
                    element: id,
                    field_name: obj.field_name,
                    ltLocalStorageKey: obj.ltLocalStorageKey
                });
                elem
                    .attr('id', id)
                    .attr(ezContenteditable, '')
                    .data(DATA_TYPE, options);
                if (ezdia.util.getEditor(id)) {
                    delete tinymce.editors[id];
                }
                elem.tinymce(options);
                self.count += 1;
            });
        };
        InlineEditor.prototype.edOnFocusOut = function () {
            var _this = this;
            setTimeout(function () {
                _this.setContent();
            }, 0);
            if (this.selectedCount) {
                this.countRow.removeClass('ez-editor-count-selected');
            }
        };
        InlineEditor.prototype.enableDisable = function (readonly) {
            if (this.readonly === readonly) {
                return;
            }
            var editors = this.cache.content_container.find('.mce-content-body');
            if (readonly) {
                this.$elem.attr('disabled', 'disabled');
                this.disableActions();
                editors.attr('contenteditable', false);
            }
            else {
                this.$elem.removeAttr('disabled');
                this.actions();
                editors.attr('contenteditable', true);
            }
            this.readonly = readonly;
        };
        InlineEditor.prototype.actions = function () {
            var _this = this;
            var config = this.options.column.config;
            var buttons = this.cache.buttons;
            var self = this;
            buttons.toggle.on("click." + DATA_TYPE, function click() {
                self.toggle(this);
            });
            buttons.add.on("click." + DATA_TYPE, function () {
                _this.add();
            });
            buttons.edit.on("click." + DATA_TYPE, function () {
                _this.edit();
            });
            buttons.edit_done.on("click." + DATA_TYPE, function () {
                _this.editDone();
            });
            if (!config.wordcount.disable) {
                this.$elem.on("change." + DATA_TYPE, function () {
                    self.$elem.htmlEditor('updateWordCount');
                });
            }
            if (!config.charcount.disable) {
                this.$elem.on("change." + DATA_TYPE, function () {
                    self.$elem.htmlEditor('updateCharCount');
                });
            }
            if (config.keywords) {
                this.$elem.on("change." + DATA_TYPE, function () {
                    self.$elem.htmlEditor('updateKeywordsCount');
                });
            }
        };
        InlineEditor.prototype.disableActions = function () {
            var buttons = this.cache.buttons;
            buttons.toggle.off("." + DATA_TYPE);
            buttons.add.off("." + DATA_TYPE);
            buttons.edit.off("." + DATA_TYPE);
            buttons.edit_done.off("." + DATA_TYPE);
            this.$elem.off("change." + DATA_TYPE);
        };
        InlineEditor.prototype.toggle = function (element) {
            var self = this;
            var elem = $(element);
            var type = elem.data('inlineEditorToggle');
            var siblings = elem.addClass('active').siblings().removeClass('active');
            if (type === 'code') {
                this.$elem.show();
                this.$elem
                    .css({
                    height: 0
                })
                    .css({
                    height: this.$elem[0].scrollHeight + 1
                });
                this.cache.container.addClass('ez-inline-editor-view-code');
                elem.nextAll().hide();
                this.$elem.on("blur." + DATA_TYPE, function blur() {
                    self.setValue(this.value);
                });
            }
            else if (type === 'design') {
                this.cache.container.removeClass('ez-inline-editor-view-code');
                siblings.show();
                this.$elem.hide();
                this.$elem.off("blur." + DATA_TYPE);
            }
        };
        InlineEditor.prototype.add = function () {
            var self = this;
            this.cache.current_selected_module = '';
            this.dialog({
                closeOnEscape: true,
                title: 'Add module',
                html: this.cache.modules_content,
                width: '100%',
                height: window.innerHeight,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Select module',
                        class: 'btn-primary',
                        click: function () {
                            self.appendSelectedModule({
                                append: true
                            });
                            $(this).dialog('close');
                        }
                    }
                ]
            });
            this.addModuleActions();
        };
        InlineEditor.prototype.edit = function () {
            var self = this;
            var cache = this.cache;
            var container = cache.content_container;
            this.dialog({
                closeOnEscape: true,
                id: dialogEditId,
                title: 'Edit layout',
                html: "<div id=\"" + editContentContainerId + "\" class=\"ez-inline-editor-container edit-content\">" + this.elem.value + "</div>",
                width: container.outerWidth(),
                height: window.innerHeight,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Done Editing',
                        class: 'btn-primary',
                        click: function () {
                            self.editDone();
                            $(this).dialog('close');
                        }
                    }
                ]
            });
            var editContentContainer = $("#" + editContentContainerId);
            editContentContainer
                .find('[data-ez-module]')
                .wrap("<div class=\" " + classes.edit_opt_wrap + "\"></div>");
            editContentContainer
                .find("." + classes.edit_opt_wrap)
                .prepend(this.options.edit_template());
            editContentContainer.sortable({
                items: "." + classes.edit_opt_wrap,
                handle: '[data-handle="move"]',
                cursor: 'move'
            });
            editContentContainer
                .find('[data-handle="remove"]')
                .on('click', function click() {
                self.deletes(this);
            });
        };
        InlineEditor.prototype.addFAQ = function () {
            var cache = this.cache;
            var container = cache.content_container;
            var questionContainer = $(container).find('.ezdia-faq-container');
            var selectedModuleName = "faq-template";
            var selectedModule = {};
            var selectedModuleTemplate = null;
            var selectedModuleTemplateAppend = null;
            selectedModule = cache.modules[selectedModuleName];
            if (!selectedModule) {
                return;
            }
            selectedModuleTemplate = selectedModule.template;
            selectedModuleTemplateAppend = $(selectedModuleTemplate).attr(dataEzAppend, 'new');
            $(questionContainer).append(selectedModuleTemplateAppend);
            this.editors({
                name: selectedModuleName,
                module: selectedModule,
                append: true
            });
        };
        InlineEditor.prototype.editDone = function () {
            var container = this.cache.content_container;
            var content = $("#" + editContentContainerId).html();
            container.html(content);
            container.find("div." + classes.edit_opt_wrap).each(function each() {
                $(this).children().unwrap();
            });
            container.find('.ez-inline-editor-btn-nav').remove();
            this.setContent();
            this.renderDefaultEditors();
            this.editorPlugin();
        };
        InlineEditor.prototype.deletes = function (element) {
            var elem = $(element);
            this.dialog({
                title: 'Delete module',
                html: 'Are you sure you want to delete this module? <br /> You will not be able to reverse this action.',
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Delete',
                        class: 'btn-primary',
                        click: function () {
                            elem.closest("." + classes.edit_opt_wrap).remove();
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        InlineEditor.prototype.resetBtns = function (disabled) {
            var cache = this.cache;
            var container = cache.container;
            if (disabled) {
                container.addClass(classes.edit_content_layout);
            }
            else {
                container.removeClass(classes.edit_content_layout);
                if (!cache.content_container.children().length) {
                    container.addClass(classes.no_content);
                }
            }
        };
        InlineEditor.prototype.addModuleActions = function () {
            var cache = this.cache;
            var id = cache.modules_content_container_id;
            var container = $("#" + id);
            var lis = container.find('li[data-list-group-item]');
            if (!lis.length) {
                return;
            }
            lis.off("." + DATA_TYPE).on("click." + DATA_TYPE, function click() {
                var elem = $(this);
                var value = elem.data('value');
                elem.addClass('selected').siblings().removeClass('selected');
                cache.current_selected_module = value;
            });
            lis.eq(0).trigger('click');
        };
        InlineEditor.prototype.getEditorOptions = function (obj) {
            var self = this;
            pageParams = $.ezdia.config.pageParams;
            var url = pageParams.ctx ? pageParams.ctx : '..';
            var tagName = obj.tagName;
            var config = obj.config || {};
            var setTime = null;
            var options = {
                field_name: obj.field_name,
                accountname: pageParams.account || '',
                role: pageParams.role || '',
                spellchecker_rpc_url: url + "/jmyspell-spellchecker",
                upload_file: config.upload || false,
                badcontent: config.badcontent || false,
                setup: function (ed) {
                    ed.on('init', function () {
                        self.cache.content_container
                            .find("[name=" + ed.id + "]")
                            .attr(ezJsSysEditorInput, '');
                    });
                    ed.on('focus', function () {
                        setTime = setInterval(function () {
                            if (!self.selectedCount) {
                                self.setContent();
                            }
                        }, self.options.updateRate);
                    });
                    ed.on('blur change', function () {
                        clearInterval(setTime);
                        self.edOnFocusOut();
                    });
                    ed.on('NodeChange', function () {
                        var tx = ed.selection.getContent();
                        if (tx) {
                            clearInterval(setTime);
                            self.selectedCount = true;
                            self.$elem.htmlEditor('updateSelectedCount', self.selectedCount, tx);
                        }
                        else if (self.selectedCount) {
                            setTime = setInterval(function () {
                                self.setContent();
                            }, self.options.updateRate);
                            self.selectedCount = false;
                            self.$elem.htmlEditor('updateSelectedCount', self.selectedCount);
                        }
                    });
                }
            };
            options = $.extend(true, {}, options, inlineBaseOptions);
            if (config.stc) {
                var htmlVal = $(obj.element).html();
                // TODO: REMOVE FIX THIS ONCE NEW CODE IS IMPLEMENTED
                var userId = pageParams.userId;
                if (!userId && ezdia.config.user) {
                    userId = ezdia.config.user.id;
                }
                options.ice = {
                    user: {
                        name: pageParams.trackChName,
                        id: userId
                    }
                };
                if (htmlVal &&
                    htmlVal.includes('data-cid') &&
                    htmlVal.indexOf('data-userid')) {
                    options.ice.isTracking = 1;
                }
                else {
                    options.ice.isTracking = 0;
                }
                options.plugins.push('ice icesearchreplace');
            }
            if (config.sct) {
                options.comments = true;
            }
            if (config.languagetool) {
                var lt = void 0;
                if (typeof config.languagetool !== 'object') {
                    lt = {
                        enable: true
                    };
                }
                else {
                    lt = config.languagetool;
                }
                options.languagetool = lt;
            }
            else {
                options.plugins.push('spellchecker');
            }
            if (config.convertUrls === false) {
                options.relative_urls = true;
                options.remove_script_host = true;
                options.convertUrls = false;
            }
            if (obj.readonly) {
                options.toolbar1 = 'false';
                options.toolbar2 = 'false';
                options.menubar = false;
                options.statusbar = false;
            }
            if (tagName === 'DIV' || tagName === 'TABLE') {
                options.plugins.push('table image media');
                if (tagName !== 'TABLE') {
                    options = this.getExtendedOptions(obj, options);
                }
            }
            else if (tagName === 'P') {
                options.plugins.push('image');
            }
            return options;
        };
        InlineEditor.prototype.getExtendedOptions = function (obj, baseOptions) {
            var options = {
                element_format: 'html',
                elements: 'advimage',
                verify_html: false,
                apply_source_formatting: false,
                relative_urls: false,
                remove_script_host: false,
                convert_urls: true,
                auto_focus: false,
                entity_encoding: 'raw',
                extended_valid_elements: 'link[*], a[href|target=_blank]',
                custom_elements: 'link',
                convertUrls: true,
                menubar: true
            };
            options.toolbar1 =
                'insertfile undo redo | styleselect | bold italic underline | bullist numlist outdent indent | link unlink | table image media | alignleft aligncenter alignright alignjustify spellchecker | code  fullscreen | forecolor backcolor';
            baseOptions.plugins.push('advlist autolink lists anchor', 'searchreplace visualblocks codemirror', 'insertdatetime paste');
            options = $.extend(true, {}, baseOptions, options);
            return options;
        };
        InlineEditor.prototype.getCleanContent = function (contentstr) {
            var content = contentstr;
            var cleanArray = [
                {
                    selector: 'grammarly-extension',
                    markup: true,
                    operation: 'remove'
                },
                {
                    selector: '.gr_spell.gr_inline_cards',
                    classes: 'gr_inline_cards',
                    operation: 'remove' // add replace
                },
                {
                    selector: '.mce-content-body',
                    classes: 'mce-content-body',
                    operation: 'remove' // add replace
                },
                {
                    selector: '.highlight-keyword',
                    classes: 'highlight-keyword',
                    operation: 'remove'
                },
                {
                    selector: '.mce-edit-focus',
                    classes: 'mce-edit-focus',
                    operation: 'remove'
                },
                {
                    selector: '[data-mce-src]',
                    attr: 'data-mce-src',
                    operation: 'remove'
                },
                {
                    selector: "[id^=\"" + prefixEd + "\"][" + ezContenteditable + "]",
                    attr: 'id',
                    operation: 'remove'
                },
                {
                    selector: "[" + ezContenteditable + "]",
                    attr: 'style',
                    operation: 'remove'
                },
                {
                    selector: "[" + ezContenteditable + "]",
                    attr: ezContenteditable,
                    operation: 'remove'
                },
                {
                    selector: "input[type=hidden][" + ezJsSysEditorInput + "]",
                    markup: true,
                    operation: 'remove'
                },
                {
                    selector: '[contenteditable]',
                    attr: 'contenteditable',
                    operation: 'remove'
                },
                {
                    selector: '[class=""]',
                    attr: 'class',
                    operation: 'remove'
                },
                {
                    selector: '[data-mce-selected]',
                    attr: 'data-mce-selected',
                    operation: 'remove'
                },
                {
                    selector: 'grammarly-btn',
                    attr: 'markup',
                    operation: 'remove'
                }
            ];
            $.each(cleanArray, function (i, obj) {
                var operation = '';
                var exp = '';
                if (obj.classes) {
                    if (obj.operation === 'remove') {
                        operation = 'removeClass';
                    }
                    else if (obj.operation === 'add') {
                        operation = 'addClass';
                    }
                    exp = obj.classes;
                }
                else if (obj.attr) {
                    if (obj.operation === 'remove') {
                        operation = 'removeAttr';
                        exp = obj.attr;
                    }
                    else if (obj.operation === 'add') {
                        operation = 'attr';
                        exp = obj.attr + ",  ";
                    }
                }
                else if (obj.markup) {
                    operation = 'remove';
                }
                if (operation) {
                    content.find(obj.selector)[operation](exp);
                }
            });
            content.find('grammarly-btn').remove();
            content = content.html() || '';
            content = content.replace(/<br data-mce-bogus="1">/gi, '');
            return content;
        };
        InlineEditor.prototype.setContent = function () {
            var container = this.cache.content_container;
            var content = container.clone();
            content = this.getCleanContent(content);
            this.setValInTextarea(content);
        };
        InlineEditor.prototype.setValInTextarea = function (value) {
            this.$elem.val(value).trigger('change');
        };
        InlineEditor.prototype.setModules = function () {
            var _this = this;
            var configModules = this.options.column.config.templates;
            var parentConfig = this.options.column.config.config || {};
            var modules = {};
            var moduleDb = [];
            var modulesPage = [];
            var moduleDbNames = [];
            $.each(configModules, function (name, obj) {
                modules[name] = obj;
                obj.config = $.extend(true, {}, parentConfig, obj.config || {});
                if (obj.template_name) {
                    moduleDb.push(name);
                    moduleDbNames.push(obj.template_name);
                }
                else if (obj.type === 'page') {
                    modulesPage.push(name);
                }
                else {
                    _this.alterModuleTemplate(obj, name);
                }
            });
            if (moduleDbNames.length) {
                moduleDbNames = $.ezdia.getEditorTemplate(moduleDbNames);
                $.each(moduleDbNames, function (i, tempObj) {
                    var name = moduleDb[i];
                    var currModule = modules[name];
                    if (tempObj) {
                        currModule.template = tempObj.content;
                        currModule.label = tempObj.label;
                        _this.alterModuleTemplate(currModule, name);
                    }
                });
            }
            if (modulesPage.length) {
                $.each(modulesPage, function (i, name) {
                    var obj = modules[name];
                    var arr = obj.template_array || [];
                    var moduleContent = '';
                    $.each(arr, function (j, mname) {
                        moduleContent += modules[mname].template || '';
                    });
                    obj.template = moduleContent;
                });
            }
            this.cache.modules = modules;
        };
        InlineEditor.prototype.setModuleContent = function () {
            var cache = this.cache;
            var id = modulesContainerprefix + this.name;
            var template = ezdia.templates.inlineEditor.templateOptions;
            var content = template({
                name: this.name,
                id: id,
                modules: cache.modules
            });
            cache.modules_content = content;
            cache.modules_content_container_id = id;
        };
        InlineEditor.prototype.dialog = function (options) {
            var wrap = $.ezdia.getWrapper(options.id || dialogId);
            var dOptions = {
                closeOnEscape: false,
                open: function (e, ui) {
                    $('.ui-dialog-titlebar-close', ui.dialog || ui).hide();
                },
                modal: true,
                title: 'Search Query',
                width: 300,
                height: 200
            };
            dOptions = $.extend(true, {}, dOptions, options);
            wrap.html(options.html);
            wrap.dialog(dOptions);
        };
        return InlineEditor;
    }());
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        setValue: InlineEditor.prototype.setValue,
        getValue: InlineEditor.prototype.getValue,
        setMode: InlineEditor.prototype.setMode
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof InlineEditor) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new InlineEditor(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn.serializeObject = function serializeObject() {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function each() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            }
            else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = InlineEditor;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
